import type { Flow, NodeKind } from '../types';
import { computeLoopBody } from './loopLayout';

// Custo estimado (mock, em R$) por tipo de nó por execução.
const NODE_COST_BRL: Record<NodeKind, number> = {
  trigger: 0,
  agent: 8,
  llm: 6,
  tool: 2,
  router: 0.5,
  loop: 0,
  memory: 0.5,
  kb: 1.5,
  human_review: 0,
  output: 0.3,
};

export function estimateNodeCost(kind: NodeKind): number {
  return NODE_COST_BRL[kind] ?? 1;
}

// Custo estimado de uma execução do fluxo (corpos de loop multiplicam pelas iterações).
export function estimateFlowRunCost(flow: Pick<Flow, 'nodes' | 'edges'>): number {
  const inLoop = new Set<string>();
  const loopBodies = new Map<string, Set<string>>();
  flow.nodes
    .filter((n) => n.kind === 'loop')
    .forEach((l) => {
      const body = computeLoopBody(flow.nodes, flow.edges, l.id);
      loopBodies.set(l.id, body);
      body.forEach((id) => inLoop.add(id));
    });

  let total = 0;
  flow.nodes.forEach((n) => {
    if (!inLoop.has(n.id)) total += estimateNodeCost(n.kind);
  });
  loopBodies.forEach((body, loopId) => {
    const loop = flow.nodes.find((n) => n.id === loopId);
    const iter = Math.max(1, Number(loop?.data.maxIterations) || 1);
    let bodyCost = 0;
    body.forEach((id) => {
      const n = flow.nodes.find((x) => x.id === id);
      if (n) bodyCost += estimateNodeCost(n.kind);
    });
    total += bodyCost * iter;
  });

  return Math.round(total * 100) / 100;
}
